import { useGetOne } from 'ra-core';
import { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { Company } from '../../types';

export const AutoPopulateCompanyDetails = () => {
    const companyId = useWatch({ name: 'company_id' });
    const { setValue, getValues } = useFormContext();

    const { data: company, isFetching } = useGetOne<Company>('companies', { id: companyId }, { enabled: !!companyId });

    const prevCompanyIdRef = useRef<any>(undefined);

    useEffect(() => {
        if (company && !isFetching) {
            // Auto-populate customer state for GST calculations
            setValue('customer_state', company.state_abbr || '', { shouldDirty: true });
            
            // Format address
            const fullAddress = [
                company.address,
                company.city,
                company.state_abbr,
                company.zipcode,
                company.country
            ].filter(Boolean).join(', ');

            const hash = window.location.hash;
            const isDC = hash.includes('delivery_challans');
            const hasBillShip = hash.includes('quotations') || hash.includes('sales_orders') || hash.includes('proforma_invoices');

            const hasExistingBilling = getValues('billing_address') !== undefined && getValues('billing_address') !== null;
            const hasExistingShipping = getValues('shipping_address') !== undefined && getValues('shipping_address') !== null;
            const hasExistingShipTo = getValues('ship_to_address') !== undefined && getValues('ship_to_address') !== null;

            const isInitialLoad = prevCompanyIdRef.current === undefined;
            prevCompanyIdRef.current = companyId;

            if (isDC) {
                if (!isInitialLoad || !hasExistingShipTo) {
                    setValue('ship_to_address', fullAddress, { shouldDirty: true });
                }
            } else if (hasBillShip) {
                if (!isInitialLoad || !hasExistingBilling) {
                    setValue('billing_address', (company as any).billing_address || fullAddress, { shouldDirty: true });
                }
                if (!isInitialLoad || !hasExistingShipping) {
                    setValue('shipping_address', (company as any).shipping_address || (company as any).billing_address || fullAddress, { shouldDirty: true });
                }
            }
        }
    }, [company, isFetching, setValue, companyId, getValues]);

    return null;
};
